// extracted by mini-css-extract-plugin
export default {"root":"GeneralTabPanel_root__4Gw5C","mobile":"GeneralTabPanel_mobile__2VXve"};